import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const PatientSearchBar = ({ searchQuery, onSearchChange }) => {
  const { t } = useTranslation();  // Translation hook

  return (
    <TextField
      fullWidth
      placeholder={t('searchPatients', 'Search patients...')}  // Translated
      value={searchQuery}
      onChange={(e) => onSearchChange(e.target.value)}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 3,
          background: 'white',
          color: '#1a1f3a',
          '& fieldset': {
            borderColor: '#E5E7EB',
          },
          '&:hover fieldset': {
            borderColor: '#D1D5DB',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#2563EB',
          },
        },
        '& .MuiInputBase-input': {
          color: '#1a1f3a',
        },
        '& .MuiInputBase-input::placeholder': {
          color: '#9CA3AF',
          opacity: 1,
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: '#9CA3AF' }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PatientSearchBar;